module.exports = "/src/views/player/help/images/mafii.jpg";